const activity = {
  activity: "Δραστηριότητα", // translated
  activities: "Δραστηριότητες", // translated
  dates: "ημερομηνίες", // translated
  location: "Τοποθεσία", // translated
  languages: "Γλώσσες", // translated
  categories: "Κατηγορίες", // translated
  ticketOption: "Επιλογή εισιτηρίου", // translated
  numberOfRatings: "Αριθμός βαθμολογιών", // translated
  meetingPointInfo: "Πληροφορίες για το σημείο συνάντησης", // translated
  meetingPoint: "Σημείο συνάντησης", // translated
  meetingPoints: "Σημεία συνάντησης", // translated
  providedBy: "Παρέχεται από", // translated
  expirationDate: "Ημερομηνία λήξης", // translated
  groupSize: "Μέγεθος ομάδας", // translated
  features: "Χαρακτηριστικά", // translated
  basedOn: "Βασισμένο στο", // translated
  reviewsFromVerCustomers: "κριτικές από επαληθευμένους πελάτες", // translated
  excellent: "έξοχος", // translated
  great: "εξαιρετική", // translated
  average: "μέση τιμή", // translated
  poor: "Φτωχός", // translated
  bad: "κακό", // translated
  onlyBookedCustomersTooltip: "Μόνο οι πελάτες που έκαναν κράτηση για αυτήν τη δραστηριότητα μπορούν να υποβάλουν κριτική", // translated
  noReviewsYet: "Προς το παρόν, δεν υπάρχουν κριτικές για αυτήν τη δραστηριότητα.", // translated
  backToActivitiesList: "Επιστροφή στη λίστα δραστηριοτήτων", // translated
  getPrices: "λάβετε τιμές", // translated
  availabilityAndPrices: "Διαθεσιμότητα και τιμές", // translated
  ticketOptions: "Επιλογές εισιτηρίων", // translated
  ticketInfo: "Πληροφορίες εισιτηρίων", // translated
  selectYourTickets: "Επιλέξτε τα εισιτήριά σας", // translated
  product: "Προϊόν", // translated
  total: "Σύνολο", // translated
  slot: "Θυρίδα", // translated
  language: "Γλώσσα", // translated
  tickets: "Εισιτήρια", // translated
  ticketsFor: "Εισιτήρια για", // translated
  previousStep: "Προηγούμενο βήμα", // translated
  onlyAvailableInEnglish: "Διατίθεται μόνο στα Αγγλικά", // translated
  guest: "Επισκέπτης", // translated
  leadGuest: "Κύριος προσκεκλημένος", // translated
  adult: "Ενήλικας", // translated
  child: "Παιδί", // translated
  pleaseSelectAdult: "Επιλέξτε τουλάχιστον έναν ενήλικα", // translated
  notAvailableActivity: "Αυτό το προϊόν δεν είναι διαθέσιμο", // translated
  required: "Απαιτείται", // translated
  pickupPoint: "Σημείο παραλαβής", // translated
  pickupPoints: "Σημεία παραλαβής", // translated
  ticketType: "Τύπος εισιτηρίου", // translated
  anonymous: "Ανώνυμος", // translated
  printedVoucher: "Έντυπο κουπόνι αποδεκτό", // translated
  mobileVoucher: "Δεκτό κουπόνι για κινητά", // translated
  mixedVoucher: "Δεκτό κουπόνι για κινητό ή έντυπο", // translated
  safetyMeasures: "Εφαρμόστηκαν μέτρα ασφαλείας", // translated
  doThisBecause: "Κάντε αυτό γιατί", // translated
  safetyInfo: "Πληροφορίες Ασφάλειας", // translated
  reviewsHighestFirst: "Αριθμός κριτικών (πρώτα η υψηλότερη)", // translated
  bookingFee: "Τέλος κράτησης", // translated
  startDate: "Ημερομηνία έναρξης", // translated
  endDate: "Ημερομηνία λήξης", // translated
  cancellationDeadlineAndFees: "Προθεσμία ακύρωσης και χρεώσεις", // translated
  resetTickets: "Επαναφορά εισιτηρίων", // translated
  instantConfirmation: "Άμεση επιβεβαίωση", // translated
  clickResetBtn: "Κάντε κλικ στο κουμπί επαναφοράς για να ξεκινήσετε ξανά την επιλογή σας", // translated
};


export default activity;
